import { DispensaryLocation, MenuItem, Review } from '../../types';

export async function retrieveLocation(
    businessId: number,
    locationId: number
): Promise<{ location: DispensaryLocation }> {
    const url = `/api/v1/businesses/${businessId}/locations/${locationId}?ddp=true`;

    const response = await fetch(url);
    return await response.json();
}

export async function retrieveMenuItems(
    businessId: number,
    locationId: number
): Promise<MenuItem[]> {
    const url = `/api/v1/businesses/${businessId}/locations/${locationId}/menu?ddp=true`;

    const response = await fetch(url);
    return await response.json();
}

export async function retrieveReviews(
    businessId: number,
    locationId: number
): Promise<{ reviews: Review[] }> {
    const url = `/api/v1/businesses/${businessId}/locations/${locationId}/reviews`;

    const response = await fetch(url);
    return await response.json();
}
